import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import {validateEmpty} from '../../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';

import {CommandUtil} from '../../../../global/commandutil';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {FormatService} from '../../../../service/format/service-format';
@Component({
  templateUrl: './butphe-edit.component.html'

})
export class CreatedButPheVanBanDenComponent implements OnInit, AfterViewInit {
  public language = language;
  public id: number=0;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public submitValidate = false;
  public  onClose: Subject<boolean>;
  constructor(
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public datepipe: DatePipe,
    public _bsModalRef: BsModalRef,
    public commandUtils: CommandUtil,
    public vanBanDenService: VanBanDenService,
    public formatService: FormatService

  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
  public edit(id: number) {
    this.id = id;


  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      noiDung: new FormControl(),
      staffId: new FormControl(),
      maVB: new FormControl(),
    });
    this.frmGroup = this.formBuilder.group({
      noiDung: ['' , Validators.compose([validateEmpty]) ],
      staffId: [Sessioncommand.staffId , Validators.nullValidator ],
      maVB: [this.id , Validators.nullValidator ],
    });
  }

  get f() { return this.frmGroup.controls; }
  public actionXuLy()
  {
    this.commandUtils.startAction();
    this.frmGroup.value.staffId= Sessioncommand.staffId;
    this.frmGroup.value.maVB = this.id;
    this.vanBanDenService.addButPhe(this.frmGroup.value
    ).subscribe(
      {
        next: (data) => {
          this.toastr.success(language.butphe_success, language.message);
          Sessioncommand.notification = false;
          Sessioncommand.vanBanDenStatus = 0;
          this.commandUtils.stopAction();
          this.onSave();
        },
        error: error => {
          Sessioncommand.notification = true;
          Sessioncommand.vanBanDenStatus = 0;
          this.commandUtils.stopAction();
          this.toastr.error(language.error, language.message);
        }
      });


  }
  public onSubmit()
  {
    this.submitValidate = true;
    if (this.frmGroup.invalid)
      return;
    this.actionXuLy();


  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

